import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmmaterialschemeitem/cecUnmMaterialSchemeItem/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmmaterialschemeitem/cecUnmMaterialSchemeItem/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmmaterialschemeitem/cecUnmMaterialSchemeItem/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmmaterialschemeitem/cecUnmMaterialSchemeItem/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmmaterialschemeitem/cecUnmMaterialSchemeItem/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmmaterialschemeitem/cecUnmMaterialSchemeItem/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmmaterialschemeitem/cecUnmMaterialSchemeItem/import',
      method: 'post',
      data: data
    })
  }
}
